import { render, staticRenderFns } from "./VxDateDropdown.vue?vue&type=template&id=ffb91d56&scoped=true"
import script from "./VxDateDropdown.vue?vue&type=script&lang=js"
export * from "./VxDateDropdown.vue?vue&type=script&lang=js"
import style0 from "./VxDateDropdown.vue?vue&type=style&index=0&id=ffb91d56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb91d56",
  null
  
)

export default component.exports